// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1SXVL","actions":"GroupTable_actions__1E_8_","deleteModalFooter":"GroupTable_deleteModalFooter__29-ey"};